import React from 'react';
import { Modal, Form, Input } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { usuariosApi } from '../../services/api';

const PasswordChangeModal = ({ visible, onCancel, onSuccess, user }) => {
    const [form] = Form.useForm();
    
    React.useEffect(() => {
        if (visible) {
            form.resetFields();
        }
    }, [visible, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            
            await usuariosApi.cambiarContrasena(user.id, {
                password: values.password,
                password_confirmation: values.password_confirmation
            });
            
         
            toast.success(`Contraseña de ${user.nombre} actualizada correctamente`, {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            
            onSuccess();
        } catch (error) {
            console.error("Error cambiando contraseña:", error);
            let errorMessage = "Error al cambiar la contraseña";
            
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message || errorMessage;
            }
            
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const modalTitle = (
        <div className="flex items-center">
            <LockOutlined className="text-xl text-gray-500 mr-2" />
            <span>{`Cambiar Contraseña - ${user ? user.nombre : ''}`}</span>
        </div>
    );

    return (
        <Modal
            title={modalTitle}
            open={visible}
            onOk={handleOk}
            onCancel={onCancel}
            okText="Cambiar Contraseña"
            cancelText="Cancelar"
            okButtonProps={{ className: "bg-gray-600 hover:bg-gray-700" }}
        >
            <div className="mb-4">
                <p className="text-gray-600">
                    Estás por cambiar la contraseña del usuario <strong>{user?.nombre}</strong>. 
                    Ingresa la nueva contraseña y confirma.
                </p>
            </div>
            
            <Form
                form={form}
                layout="vertical"
                name="passwordForm"
                className="[&_.ant-form-item]:mb-4"
            >
                <Form.Item
                    name="password"
                    label="Nueva Contraseña"
                    rules={[{ required: true, message: 'Por favor ingrese la nueva contraseña' }]}
                >
                    <Input.Password placeholder="Nueva contraseña" size="large" />
                </Form.Item>

                <Form.Item
                    name="password_confirmation"
                    label="Confirmar Nueva Contraseña"
                    dependencies={['password']}
                    rules={[
                        {
                            required: true,
                            message: 'Por favor confirme la contraseña',
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Las contraseñas no coinciden'));
                            },
                        }),
                    ]}
                >
                    <Input.Password placeholder="Confirmar nueva contraseña" size="large" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default PasswordChangeModal;